/*!
    * @product/scmp-sdk 1.0.215
    * 4ea66bed59ebf69ab054abb30a7e3308ecad0a86
  */
import{h as t}from"./chunk-6ZQIBI2V.js";var r=()=>{let{acquisition:{getPersonalizationByExperimentId:e,getVariantByExperimentId:i,uiTestingState:o}}=t();return{getPersonalizationByExperimentId:e,getVariantByExperimentId:i,uiTestingState:o}};export{r as a};
//# sourceMappingURL=chunk-NGARFO4R.js.map
